import React from 'react'
import { components } from 'react-select'

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const weekdayNames = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

export const portionTypes = [
  'bowl',
  'batch'
]

export const disabledIconColor = '#CCCCCC'

export const customSelectOption = (props) => (
  <components.Option {...props} className='select-option d-flex align-items-center'>
    {props.data.imageUrl && <img src={props.data.imageUrl} />}
    {props.data.label}
  </components.Option>
)

export const customSelectValue = (props) => (
  <components.SingleValue {...props} className='d-flex align-items-center'>
    {props.data.imageUrl && <img src={props.data.imageUrl} />}
    {props.data.label}
  </components.SingleValue>
)

export const customValueContainerWithPlaceholder = ({ children, ...props }) => {
  const values = React.Children.map(children, child => {
    if (child && child.type !== components.Placeholder) {
      return React.cloneElement(child, { className: `${child.props.className} d-flex align-items-center absolute-right-10` })
    }
  })

  return (
    <components.ValueContainer {...props}>
      {values}
    </components.ValueContainer>
  )
}
